import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../utils/cn";

const headingVariants = cva("text-black", {
  variants: {
    headingSize: {
      h1: "mb-5 text-6xl font-bold md:mb-6 md:text-9xl lg:text-10xl",
      h2: "text-4xl",
      h3: "text-2xl",
    },
  },
  defaultVariants: {
    headingSize: "h1",
  },
});

type CustomProps = {
  text?: string;
};

export interface HeadingProps
  extends React.HTMLProps<HTMLHeadingElement>,
    CustomProps,
    VariantProps<typeof headingVariants> {}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, children, text, headingSize, ...props }, ref) => {
    return (
      <h1 className={cn(headingVariants({ headingSize, className }))} ref={ref} {...props}>
        {text}
        {children}
      </h1>
    );
  },
);
Heading.displayName = "Heading";

export { Heading };
